/* eslint-disable radix */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import imageSources from '../../../../../../../../constants/imageSources/imageSources';
import configs from '../../../../../../../../constants/configs';
import { elementContentType } from '../../../../../../../../types';

export default class VideoElement extends PureComponent {
    render() {
        const { content, width, imageHeight } = this.props;
        const { paddingTop, paddingRight, paddingBottom, paddingLeft, rawSource, playButtonColor } = content;
        const imageWidth = width - (paddingLeft + paddingRight);
        const isPlaceholder = rawSource.length === 0;
        const placeHolderImageDimension = Math.min(imageWidth, imageHeight);
        let thumbnailSrc = '';
        if (!isPlaceholder) {
            const playButtonOverlaySrc =
                playButtonColor === 'black' ? imageSources.PLAY_BUTTON.BLACK : imageSources.PLAY_BUTTON.WHITE;
            thumbnailSrc = `${configs.emailDesignerAPI}/watermark?img=${encodeURIComponent(
                rawSource
            )}&overlay=${encodeURIComponent(playButtonOverlaySrc)}`;
        }

        return (
            // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
            <table style={{ width: '100%' }} cellSpacing="0" cellPadding="0" tabIndex="0">
                <tbody>
                    <tr>
                        <td>
                            {isPlaceholder ? (
                                <div
                                    style={{
                                        width: imageWidth,
                                        height: imageHeight,
                                        paddingTop,
                                        paddingBottom,
                                        paddingLeft,
                                        paddingRight,
                                        position: 'relative',
                                        display: 'block',
                                    }}
                                >
                                    <div
                                        style={{
                                            position: 'relative',
                                            backgroundColor: '#F7F9FA',
                                            width: '100%',
                                            height: placeHolderImageDimension,
                                            textAlign: 'center',
                                        }}
                                    >
                                        <img
                                            draggable="false"
                                            src={imageSources.PLACEHOLDERS.VIDEO_UPLOAD}
                                            alt="placeholder icon"
                                            style={{
                                                margin: '0 auto',
                                                height: placeHolderImageDimension,
                                                width: placeHolderImageDimension,
                                            }}
                                        />
                                        <p
                                            style={{
                                                fontSize: 16,
                                                fontWeight: 'bold',
                                                color: '#424242',
                                                position: 'absolute',
                                                width: imageWidth,
                                                textAlign: 'center',
                                                bottom: `calc(100% - ${placeHolderImageDimension - 6}px)`,
                                            }}
                                        >
                                            {parseInt(imageWidth)} px
                                        </p>
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    <img
                                        draggable="false"
                                        src={thumbnailSrc}
                                        alt={content.alt}
                                        style={{
                                            width: imageWidth,
                                            height: imageHeight,
                                            paddingTop,
                                            paddingBottom,
                                            paddingLeft,
                                            paddingRight,
                                        }}
                                    />
                                </div>
                            )}
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    }
}

VideoElement.propTypes = {
    content: elementContentType.isRequired,
    width: PropTypes.number.isRequired,
    imageHeight: PropTypes.number.isRequired,
};
